// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"127":"search-modal","764":"markdown"}[chunkId] || chunkId) + "-" + {"69":"7d70a2cc31432600466e","127":"0671e70a441473e21f75","764":"a34a58926d4398a603a3"}[chunkId] + ".chunk.js";
};